import React from 'react';
import { Github,Linkedin , MailCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import './contacts.css'


const Heros = () => {
  return (
    <section
    className="h-max md:h-screen text-white bg-gradient-to-b from-gray-100 to-gray-200 flex flex-col justify-center items-center relative z-10 pb-10 overflow-y-hidden"
    
  >
      <div className='shooting-stars'>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className='max-w-7xl mt-24 mx-auto items-center flex flex-col md:flex-row gap-16 md:gap-40 justify-between'>
        <div className='md:space-y-6 px-4'>
          <motion.h1 
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className='md:text-6xl text-4xl font-bold mb-4 text-black'>
            Hey there, I'm <p className='text-black'>Sophie  <span className='text-black'>Muchiri</span></p>
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.2, delay: 0.4 }}
            className='md:text-2xl text-lg mb-3 text-black'>
            Full-Stack Developer  | Frontend Development Enthusiast | User-Centered Design
          </motion.p>
          <motion.p 
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.4, delay: 0.5 }}
            className='lg:w-[600px] mb-4 md:mb-0 text-sm text-black'>
            Feel free to reach out to me via any of the platforms below.
          </motion.p>
          <motion.a 
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.4, delay: 0.5 }}
            href="https://github.com/Sophie-Muchiri12"
            target="_blank"
            rel="noopener noreferrer"
            className='px-2 py-2 flex items-center gap-2 rounded-md text-white text-center hover:bg-gray-600  transition-all'>
            <Github className="w-10 h-10 p-2 border-2 border-red-400 rounded-full text-white bg-black hover:bg-gray-600 transition-all" /> <span className='text-black'>Github</span> 
          </motion.a>

          <motion.a 
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.4, delay: 0.5 }}
            href="https://www.linkedin.com/in/sophie-muchiri-3aa207273/"
            target="_blank"
            rel="noopener noreferrer"
            className='px-2 py-2 flex items-center gap-2  rounded-md text-white text-center hover:bg-gray-600  transition-all'>
            <Linkedin className="w-10 h-10 p-2 border-2 border-red-400 rounded-full text-white bg-black hover:bg-gray-600 transition-all"/> <span className='text-black'>LinkedIn</span>
          </motion.a>

          <motion.a 
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.4, delay: 0.5 }}
            href="mailto:muthonisophie12@gmail.com?subject=Inquiry&body=I%20would%20like%20to%20ask%20about..."
            rel="noopener noreferrer"
            className='px-2 py-2 flex items-center gap-2  rounded-md text-white text-center hover:bg-gray-600  transition-all'>
            <MailCheck className="w-10 h-10 p-2 border-2 border-red-400 rounded-full text-white bg-black hover:bg-gray-600 transition-all"/> <span className='text-black'>Gmail</span>
          </motion.a>

          



          
        </div>
      </div>
    </section>
  );
};

export default Heros